import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzBadgeModule } from 'ng-zorro-antd/badge';

import { NegotiationsCounterComponent } from './negotiations-counter.component';

@NgModule({
  declarations: [NegotiationsCounterComponent],
  imports: [CommonModule, NzBadgeModule],
  exports: [NegotiationsCounterComponent],
})
export class NegotiationsCounterModule {}
